import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.data
}

const addVariantMasterApi = (requestBody: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.addVariantToMaster),
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      deviceId: requestBody['Device Id'],
      variantId: requestBody['Variant Id'],
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addVariantMasterApi }
